import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { content: String }

  copy() {
    navigator.clipboard.writeText(this.contentValue)

    const svg = this.element.querySelector("svg")
    svg.classList.add("text-green-600")
    setTimeout(() => svg.classList.remove("text-green-600"), 1500)
  }
}
